import React from 'react';
import {
  Dialog,
  DialogActions,
  Divider,
  Grid,
  IconButton
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { createStyles, makeStyles } from '@material-ui/core';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { IDialogContentsProps } from './RightSide/types';

interface Props {
  open: boolean;
  onClose: () => void;
  contents: IDialogContentsProps;
}

export default function PlacingAnOrderDialog(props: Props): JSX.Element {
  const classes = useStyles();
  const { open, onClose, contents } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.root}
      maxWidth="xs"
    >
      <Grid className={classes.header}>
        <CustomizedTypography variant="h4" fontWeight="700">
          발주하기
        </CustomizedTypography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </Grid>
      <Grid className={classes.content}>
        <CustomizedTypography variant="h4" color="textPrimary">
          {contents.mainContent}
        </CustomizedTypography>
        <CustomizedTypography
          variant="body1"
          color="textSecondary"
          gutterBottoms={24}
        >
          {contents.subContent}
        </CustomizedTypography>
      </Grid>
      <Divider />
      <DialogActions className={classes.footer}>
        <CustomizedButton
          className={classes.confirmButton}
          color="primary"
          onClick={contents.action}
        >
          {contents.button}
        </CustomizedButton>
      </DialogActions>
    </Dialog>
  );
}

const useStyles = makeStyles((theme) => {
  return createStyles({
    root: {
      '& .MuiPaper-root': {
        borderRadius: 16
      }
    },
    header: {
      margin: 0,
      padding: `28px 24px`
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    content: {
      padding: `0px 24px`,
      whiteSpace: `pre-wrap`
    },
    footer: {
      display: 'flex',
      padding: `17px 24px`
    },
    confirmButton: {
      flexGrow: 1
    }
  });
});
